import React from 'react';
import { withPrefix, Link } from 'gatsby';
import queryString from 'query-string';
import { ToastContainer, toast } from 'react-toastify';

const GUID = '4bb68bc5-6fd0-4f9e-bd9f-23d955dc114c';
const PORTAL = '5571282';

export default class Newsletter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locale: props.locale,
      email: '',
      canSubmit: false,
      success: false,
    };
  }

  changeInput = () => {
    console.log("changed")
  }

  render() {
    let locale = this.state.locale;
    return (
      <section className="newsletter">
        <div className="container">
          <div className="column innerfix">
            <section className="headliner">
              <div className="container">
                <div className="column">
                  <h2>
                    Stay up-to-date { locale === "en" ? "with our" : "mit unserem" } <strong>Newsletter</strong>
                  </h2>
                  <p>
                    { locale === "en" ?
                    "Yes, I would like to receive individual emails from presono with information & valuable tips about presenting." :
                    "Ja, ich möchte individuelle E-Mails mit Informationen und wertvollen Tipps zum Thema Präsentieren von presono erhalten."
                    }
                  </p>
                </div>
                <div className="column">
                  <div className="field">
                    <form 
                      action="https://presono.us4.list-manage.com/subscribe/post?u=5ce004b7cd6c303fae3aacb26&amp;id=8155998d53" 
                      method="post" 
                      id="mc-embedded-subscribe-form" 
                      name="mc-embedded-subscribe-form" 
                      className="validate" 
                      target="_blank" 
                      >
                      <div id="mc_embed_signup_scroll">
                        <input type="email" name="EMAIL" className="input is-rounded" id="mce-EMAIL" placeholder={ locale === "en" ? "email address" : "Email Adresse" } required defaultValue="" />
                        <div style={{position: 'absolute', left: '-5000px'}} aria-hidden="true">
                          <input type="text" name="b_5ce004b7cd6c303fae3aacb26_8155998d53" tabIndex="-1" defaultValue=""/>
                        </div>
                        <input type="submit" value={ locale === "en" ? "Subscribe" : "Anmelden" } name="subscribe" id="mc-embedded-subscribe" className="button is-rounded newsletter-button"/>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    );
  }
}
